export default {
  goal: 'Accéder au parcours de conseil retraite',
  goalRetired: 'Parcours indisponible aux retraités',
  goalWarning: 'Compléter votre carrière pour accéder au parcours',
  label: 'Votre retraite',
  title: 'Votre retraite',
}
